'use strict';

angular.module('atex.dam').controller('DamClipboardController',
['$scope', '$rootScope', '$window', 'AuthenticationService', 'Application', 'ContentService', 'DamNotificationService',
  'DamService', 'ClipboardService', '$translate', '$document', '$state', '$stateParams', 'ExportService',
  'CollectionService', '$q', 'DamActivityService', 'PublishService', 'DamAclPermissionService', 'LocalAppService',
  'UserProfileService','TypeSetConfirmModal','DamTemplateService','DamRestrictContentService','$timeout',
function($scope, $rootScope, $window, AuthenticationService, Application, ContentService, DamNotificationService,
         DamService, ClipboardService, $translate, $document, $state, $stateParams, ExportService,
         CollectionService, $q, DamActivityService,PublishService, DamAclPermissionService, LocalAppService,
         UserProfileService, TypeSetConfirmModal, DamTemplateService, DamRestrictContentService, $timeout) {

  $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__', '_NO_EDIT_PERMISSION_LABEL_','__ERROR_RETRIEVE_CLIPBOARD__','__DUPLICATE_CONFIRM_HEADER__','__DUPLICATE_CONFIRM_BODY__']).then(function (translations) {
    $scope.message = {
      error:{},
      popup:{}
    };

    $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
    $scope.message.error.generic = translations.__GENERIC_ERROR_MSG__;
    $scope.message.error.edit = translations._NO_EDIT_PERMISSION_LABEL_;
    $scope.message.error.clipboard = translations.__ERROR_RETRIEVE_CLIPBOARD__;

    $scope.message.popup.header = translations.__DUPLICATE_CONFIRM_HEADER__;
    $scope.message.popup.body = translations.__DUPLICATE_CONFIRM_BODY__;
  });

  $scope.profileConfiguration = {
    "openIntent": "web"
  };

  UserProfileService.getConfigurationById({
    application:'desk',
    id: 'copyfit-configurations'
  }).then(function (configuration) {
    _.extend( $scope.profileConfiguration, configuration);
  });

  $scope.preview = function(entries) {
    entries.map(function(entry) {
      $window.open('/act/#/preview/'+entry.id, '_blank').focus();
    });
  };

  function createEngagementAspect(content) {
    var aspect = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.original.content/data');

    var engage;
    if(aspect) {
      engage = {};
      engage.timestamp = aspect.timestamp;
      engage.appType = aspect.application;
      engage.userName = aspect.userName;
      engage.attributes = {};
    }

    return engage;
  }

        $scope.runSafety = function (action, popupCheck, entries, templates, templateId) {
          if (action === undefined) {
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'error',
              message: 'Missing configuration'
            }), true);
            return;
          }
          if (popupCheck && entries &&  typeof $scope[popupCheck] === 'function'&&$scope[popupCheck](entries)) {
            var prompt = $scope.duplicatePrompt(function(value){
              if(value){
                $scope[action](entries, templates, templateId);
              }
            });
          } else {
            $scope[action](entries, templates, templateId);
          }

  };


  $scope.duplicatePrompt = function(callback){
    var confirmModal = TypeSetConfirmModal.create({
      'confirmHeader': $scope.message.popup.header,
      'confirmBody': $scope.message.popup.body,
      'mode': 'primary'
    });
    confirmModal.show = true;
    confirmModal.then(function (confirmed) {
      if (confirmed === 'ok') {
        callback(true);
      }else if (confirmed === 'cancel') {
        confirmModal.show = {};
        confirmModal.show = false;
        callback(false);
      }
    });
  };

  $scope.duplicate = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    $window.atex.analytics('event', { e: 'duplicate', d1: ids });
    DamService.duplicate(atex.dam.AngularUtils.getIdsArray(entries)).then(function (contents) {
      contents.forEach(function (content) {
        ContentService.getContent({id: content}).then(function (entry) {
          atex.dam.AngularUtils.fixUrls(entry.data);
          entry._data = entry.data;
          entry.engage = createEngagementAspect(entry);
          $rootScope.entryToaddInlistAfterDuplication = entry;
          $state.go('list.engagements', {'items': entry});
        }).then(null, function (error) {
          var message = $scope.message.error.generic + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      });
      DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), false);
    }).then(null, function (error) {
      var message = $scope.message.error.generic + " (" + error.cause + ")";
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
    });
  };

  $scope.restrictContent = function (entries){
    if (entries !== undefined) {
      DamRestrictContentService.restrictContent(entries);
    }
  };

  $scope.unRestrictContent = function (entries){
    if (entries !== undefined) {
      DamRestrictContentService.unRestrictContent(entries);
    }
  };

  $scope.open = function(entries) {
    var deferred = $q.defer();
    var ids = atex.dam.AngularUtils.getIdsArray(entries);

    DamAclPermissionService.hasWritePermission(ids).then(function (hasPermission) {
      if (!hasPermission) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $scope.message.error.edit }), true);
        return;
      }
      DamActivityService.getLockData(ids).then(function(lockData){
        if (lockData.edit) {
          DamActivityService.notifyItemLocked(lockData.getUserName());
          deferred.reject({});
        } else {
          entries.forEach(function (entry) {
            var addIntent = "";
            if (typeof $scope.profileConfiguration.openIntent !== 'undefined') {
              addIntent = "?intent=" + $scope.profileConfiguration.openIntent;
            }
            $window.open('/act/#/edit/'+entry.id + addIntent, '_blank').focus();
          });
          deferred.resolve();
        }
      }).then(null, function(error) {
        deferred.reject(error);
      });
    });
    return deferred.promise;
  };

  $scope.isInPublication = function(entries){
    if (entries.length>0) {
      entries.forEach(function (entry) {
        var isAssigned = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.dam.standard.Publevents/data/publevents/0');
        var pubInfo = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents/0");
        var objectType = atex.onecms.ObjectUtils.getByPath(entry,"_data/aspects/contentData/data/objectType");

        var isPlaced = (pubInfo && (pubInfo.page) && (objectType !== "page") && (pubInfo.pending !== true));
        console.log("isAssigned",isAssigned,"isPlaced",isPlaced);
      return isAssigned || isPlaced;
        //return true;
      });
    }
    return false;
  };
  $scope.editUsing = function(entries, templateId) {
    var deferred = $q.defer();
    var ids = atex.dam.AngularUtils.getIdsArray(entries);

    DamAclPermissionService.hasWritePermission(ids).then(function (hasPermission) {
      if (!hasPermission) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $scope.message.error.edit }), true);
        return;
      }
      DamActivityService.getLockData(ids).then(function(lockData){
        if (lockData.edit) {
          DamActivityService.notifyItemLocked(lockData.getUserName());
          deferred.reject({});
        } else {
          entries.forEach(function(entry) {
            var addIntent = "";
            if ($scope.profileConfiguration.openIntent !== undefined){
              addIntent = "?intent=" + $scope.profileConfiguration.openIntent;
            }
            $window.open('/act/#/editUsing/' + entry.id + "/" + templateId + addIntent, '_blank').focus();
          });
          deferred.resolve();
        }
      }).then(null, function(error) {
        deferred.reject(error);
      });
    });
    return deferred.promise;
  };

  $scope.editLocal = function(entries) {
    entries.forEach(function(entry) {
      if (entry._data.aspects['atex.print.Page']) {
        var printPage = entry._data.aspects['atex.print.Page'].data;

        if ( LocalAppService && LocalAppService.isAvailable() &&
              typeof printPage !== 'undefined' && typeof printPage.pageId !== 'undefined' &&
              printPage.pageId !== '' ) {
          LocalAppService.callLocalApp( printPage.pageId, {}, false );
        } else {

        }
      }
    });

//    var deferred = $q.defer();

//    var ids = atex.dam.AngularUtils.getIdsArray(entries);
//    DamAclPermissionService.hasWritePermission(ids).then(function (hasPermission) {
//      if (!hasPermission) {
//        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $scope.message.error.edit }), true);
//        return;
//      }
//      DamActivityService.getLockData(ids).then(function(lockData){
//        if (lockData.edit) {
//          DamActivityService.notifyItemLocked(lockData.getUserName());
//          deferred.reject({});
//        } else {
//          entries.forEach(function(entry) {
//            $window.open('/act/#/editUsing/' + entry.id + "/" + templateId, '_blank').focus();
//          });
//          deferred.resolve();
//        }
//      }).then(null, function(error) {
//        deferred.reject(error);
//      });
//    });
//    return deferred.promise;
  };

  $scope.copy = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    DamActivityService.getLockData(ids).then(function(lockData){
      if (lockData.edit) {
        DamActivityService.notifyItemLocked(lockData.getUserName());
      } else {
        var clipboardInfo = {};
        clipboardInfo.data = [];
        ExportService.clipboardExport(entries).then(function(data) {
          return ClipboardService.putInClipboard(data.clipboard).then(function(response) {
            DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message.success }), false);
          }, function(error) {
            DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $scope.message.error.clipboard }), true);
          });
        });
      }
    });
  };

  $scope.edit = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    DamActivityService.getLockData(ids).then(function(lockData){
      if (lockData.edit) {
        DamActivityService.notifyItemLocked(lockData.getUserName());
      } else {
        ExportService.export(entries).then(function(exported) {
          $scope.open(exported).then(function(){}
          );
        });
      }
    });
  };

  function notifyUpdates(ids) {
    ids.forEach(function(id) {
      $rootScope.$broadcast('dam:updatedItem', {'id': id});
    });
  }

  function wrapInLock(ids, cb) {
    DamActivityService.getLockData(ids).then(function(lockData){
      if (lockData.edit) {
        DamActivityService.notifyItemLocked(lockData.getUserName());
      } else {
        DamActivityService.lock(ids).then(function(responses) {
          cb().then(function (exported) {
            DamActivityService.unlock(ids);
            notifyUpdates(ids);
            DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $scope.message.success}), false);
          }, function (error) {
            // error is an array of errors, check to see if the caller has already displayed an error
            var isHandled = (Array.isArray(error) && error[0].reason.messageHandled);
            DamActivityService.unlock(ids);
            if (!isHandled) {
              DamNotificationService.addNotification(atex.dam.Notification({
                type: 'error',
                message: $scope.message.error.clipboard
              }), true);
            }
          });
        });
      }
    });
  }

  $scope.publish = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    $window.atex.analytics('event', { e: 'publish', d1: ids });
    wrapInLock(ids, function() {
      return PublishService.publish(entries);
    });
  };

  $scope.unpublish = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    $window.atex.analytics('event', { e: 'unpublish', d1: ids });
    wrapInLock(ids, function() {
      return PublishService.unpublish(entries);
    });
  };

  $scope.add = function(entries) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    $window.atex.analytics('event', { e: 'copyToClipboard', d1: ids });
    var clipboardInfo = {};
    clipboardInfo.data = [];
    entries.forEach(function(entry) {
      var data = {
          id: 'contentid/'+entry.id,
          type: entry._data.aspects.contentData.data._type
      };
      clipboardInfo.data.push(data);
    });
    return ClipboardService.putInClipboard(clipboardInfo).then(function(response){
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message.success }), false);
    }, function(error) {
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $scope.message.error.clipboard }), true);
    });
  };

  $scope.export = function(entries,templates,template,destination,status) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);

    DamActivityService.getLockData(ids).then(function(lockData){
	  if (lockData.edit) {
	    DamActivityService.notifyItemLocked(lockData.getUserName());
	  } else {
	    ExportService.export(entries,template,destination,status).then(function() {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message.success }), false);
      });
	  }
	});
  };

  $scope.openUsing = function(entries, templates, templateId) {
    var ids = atex.dam.AngularUtils.getIdsArray(entries);
    DamActivityService.getLockData(ids).then(function (lockData) {
      if (lockData.edit) {
        DamActivityService.notifyItemLocked(lockData.getUserName());
      } else {
        ExportService.export(entries).then(function (exported) {
          if(templateId) {
            $scope.editUsing(exported, templateId);
          } else {
            $scope.open(exported);
          }
        });
      }
    });
  };

  $scope.engageAndOpenWithTemplateDialog = function(entries, force, templates, inputTemplate, destination, status){
    var deferred = $q.defer();
    var ids = atex.dam.AngularUtils.getIdsArray(entries);

    DamAclPermissionService.hasWritePermission(ids).then(function (hasPermission) {
      if (!hasPermission) {
        var msg = $translate.getTranslationTable().___NO_EDIT_PERMISSION_LABEL_;
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: msg}), true);
        deferred.reject({});
        return;
      }
      DamActivityService.getLockData(ids).then(function(lockData){
        if (lockData.edit) {
          DamActivityService.notifyItemLocked(lockData.getUserName());
          deferred.reject({});
        } else {
          entries.forEach(function (entry) {
            DamTemplateService.selectTemplateFor(entry).then(function (template) {
              if (template) {
                return ExportService.export([entry], inputTemplate, destination, status).then(function (newEntries) {
                  if (newEntries) {
                    newEntries.forEach(function(newEntry) {
                      $window.open('/act/#/editUsing/' + newEntry.id + "/" + template.id, '_blank').focus();
                    });
                  }
                });
              }
            });
          });
          deferred.resolve();
        }
      }).then(null, function(error) {
        deferred.reject(error);
      });
    });
    return deferred.promise;
  };



  $scope.notifyError = function (error) {
    var errorMessage = (error.data && error.data.message) || error.cause || error.statusText || error;
    var message = $scope.message.error.generic + " (" + errorMessage + ")";
    DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
  };

  $scope.createPrintVariantImage = function (entries) {
    AuthenticationService.getCurrentUser().then(function () {
      entries.forEach(function (entry) {
        DamService.createPrintVariantImage(entry.id).then(function (response) {
          return ContentService.getContent({id: response}).then(function () {
            $timeout(function () {
              DamNotificationService.addNotification(atex.dam.Notification({
                type: 'success',
                message: $scope.message.success
              }), false);
              $rootScope.$broadcast("dam:refresh");
            }, 2000);
          }, function (error) {
            $scope.notifyError(error);
          });
        }, function (error) {
          $scope.notifyError(error);
        });
      });
    });
  };

}]);
